export default "__VITE_ASSET__FaHS4JBO__"